
import { useState, useEffect } from 'react';

const reviews = [
  {
    id: 1,
    name: 'سارة أحمد',
    rating: 5,
    comment: 'منتجات رائعة وجودة عالية! سيروم فيتامين سي غير حياة بشرتي تماماً. أصبحت بشرتي أكثر إشراقاً ونضارة.',
    product: 'سيروم فيتامين سي',
    date: 'منذ أسبوعين',
    avatar: 'https://public.readdy.ai/ai/img_res/b2c973a3839b1c986a981a92d9e81887.jpg'
  },
  {
    id: 2,
    name: 'نورة محمد',
    rating: 5,
    comment: 'أحب كل شيء في Rose Mist! التغليف فاخر والمنتجات فعالة جداً. خدمة العملاء ممتازة والتوصيل سريع.',
    product: 'كريم الترطيب المكثف',
    date: 'منذ 3 أيام',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20beautiful%20arab%20woman%20with%20perfect%20skin%2C%20beauty%20photography%2C%20soft%20pink%20background%2C%20elegant%20makeup%2C%20feminine%20aesthetic%2C%20high%20quality%20headshot&width=100&height=100&seq=avatar2&orientation=squarish'
  },
  {
    id: 3,
    name: 'ريم خالد',
    rating: 5,
    comment: 'أفضل متجر تجميل! المنتجات طبيعية وآمنة على البشرة. أحمر الشفاه المات يدوم طوال اليوم دون أن يجف الشفاه.',
    product: 'أحمر شفاه مات',
    date: 'منذ أسبوع',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20middle%20eastern%20woman%20with%20radiant%20skin%2C%20beauty%20photography%2C%20soft%20pink%20background%2C%20natural%20elegant%20makeup%2C%20feminine%20aesthetic&width=100&height=100&seq=avatar3&orientation=squarish'
  },
  {
    id: 4,
    name: 'لينا عبدالله',
    rating: 5,
    comment: 'عطر Rose Mist الفاخر رائحته خيالية! يدوم طويلاً وأتلقى الكثير من الإطراءات عليه. سأشتري منه مرة أخرى بالتأكيد.',
    product: 'عطر Rose Mist',
    date: 'منذ 5 أيام',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20arab%20woman%20with%20flawless%20skin%2C%20beauty%20photography%2C%20soft%20pink%20background%2C%20sophisticated%20makeup%2C%20feminine%20aesthetic%2C%20high%20quality&width=100&height=100&seq=avatar4&orientation=squarish'
  },
  {
    id: 5,
    name: 'مريم سعيد',
    rating: 5,
    comment: 'تجربة تسوق رائعة! الموقع سهل الاستخدام والمنتجات وصلت بحالة ممتازة. باليت ظلال العيون ألوانها خيالية.',
    product: 'باليت ظلال العيون',
    date: 'منذ 4 أيام',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20beautiful%20middle%20eastern%20woman%20with%20glowing%20complexion%2C%20beauty%20photography%2C%20soft%20pink%20background%2C%20natural%20makeup%2C%20feminine%20aesthetic&width=100&height=100&seq=avatar5&orientation=squarish'
  },
  {
    id: 6,
    name: 'هند علي',
    rating: 5,
    comment: 'منتجات Rose Mist أصبحت جزء أساسي من روتيني اليومي. لوشن الجسم بالورد رائحته جميلة ويرطب البشرة بعمق.',
    product: 'لوشن الجسم بالورد',
    date: 'منذ أسبوع',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20young%20arab%20woman%20with%20perfect%20skin%2C%20beauty%20photography%2C%20soft%20pink%20background%2C%20elegant%20natural%20makeup%2C%20feminine%20aesthetic%2C%20high%20quality&width=100&height=100&seq=avatar6&orientation=squarish'
  }
];

const CustomerReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsPerView(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerView(2);
      } else {
        setItemsPerView(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prev) => 
      prev + itemsPerView >= reviews.length ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => 
      prev === 0 ? Math.max(0, reviews.length - itemsPerView) : prev - 1
    );
  };

  return (
    <section className="py-20 bg-gradient-to-b from-rose-50/30 to-white" dir="rtl">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
            آراء عملائنا
          </h2>
          <p className="text-gray-600">ما يقوله عملاؤنا عن منتجاتنا</p>
        </div>

        <div className="relative">
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out gap-6"
              style={{ transform: `translateX(${currentIndex * (100 / itemsPerView)}%)` }}
            >
              {reviews.map((review) => (
                <div
                  key={review.id}
                  className="flex-shrink-0 bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow"
                  style={{ width: `calc(${100 / itemsPerView}% - ${(itemsPerView - 1) * 24 / itemsPerView}px)` }}
                >
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-14 h-14 flex items-center justify-center overflow-hidden rounded-full">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-semibold text-gray-800">{review.name}</h4>
                      <p className="text-xs text-gray-500">{review.date}</p>
                    </div>
                  </div>

                  <div className="flex gap-1 mb-3">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-400 text-base"></i>
                    ))}
                  </div>

                  <p className="text-gray-600 text-sm leading-relaxed mb-3">
                    {review.comment}
                  </p>

                  <p className="text-xs text-rose-400 font-medium">
                    المنتج: {review.product}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {reviews.length > itemsPerView && (
            <>
              <button
                onClick={prevSlide}
                className="absolute right-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-rose-50 transition-colors z-10 cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
              </button>
              <button
                onClick={nextSlide}
                className="absolute left-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-11 h-11 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-rose-50 transition-colors z-10 cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
              </button>
            </>
          )}
        </div>

        <div className="text-center mt-12">
          <div className="inline-flex items-center gap-2 text-gray-600">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-xl"></i>
              ))}
            </div>
            <span className="text-lg font-semibold">4.9</span>
            <span className="text-sm">من 5 بناءً على 1,234 تقييم</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviews;
